import { render, staticRenderFns } from "./HotProduct.vue?vue&type=template&id=14a6f5bd&scoped=true"
import script from "./HotProduct.vue?vue&type=script&lang=js"
export * from "./HotProduct.vue?vue&type=script&lang=js"
import style0 from "./HotProduct.vue?vue&type=style&index=0&id=14a6f5bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a6f5bd",
  null
  
)

export default component.exports